var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "justify-center d-flex mt-n16" },
        [
          _c(
            "v-col",
            { staticClass: "mx-auto", attrs: { lg: "4", md: "7" } },
            [
              _c("v-card", { staticClass: "card-shadow border-radius-xl" }, [
                _c("div", { staticClass: "card-padding text-center" }, [
                  _c(
                    "h5",
                    { staticClass: "text-h5 text-typo font-weight-bold" },
                    [_vm._v("Verify your email")]
                  ),
                  _c(
                    "p",
                    { staticClass: "text-sm text-body mt-2 mb-0" },
                    [
                      _vm.pending
                        ? [
                            _vm._v(" We sent a verification code to "),
                            _c("strong", [_vm._v(_vm._s(_vm.pending.email))]),
                            _vm._v(". "),
                          ]
                        : [
                            _vm._v(
                              " We couldn't find your sign-up in this browser. Please sign up again to get a new code. "
                            ),
                          ],
                    ],
                    2
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "card-padding" },
                  [
                    _c("v-text-field", {
                      class: _vm.inputClass,
                      attrs: {
                        disabled: !_vm.pending,
                        "hide-details": "",
                        outlined: "",
                        "background-color": "rgba(255,255,255,.9)",
                        color: "rgba(0,0,0,.6)",
                        light: "",
                        height: "40",
                        placeholder: "Verification code",
                        autocomplete: "one-time-code",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.confirm()
                        },
                      },
                      model: {
                        value: _vm.code,
                        callback: function ($$v) {
                          _vm.code = $$v
                        },
                        expression: "code",
                      },
                    }),
                    _vm.errorMessage
                      ? _c("p", { staticClass: "text-sm text-danger mb-0" }, [
                          _vm._v(_vm._s(_vm.errorMessage)),
                        ])
                      : _vm._e(),
                    _vm.infoMessage
                      ? _c("p", { staticClass: "text-sm text-success mb-0" }, [
                          _vm._v(_vm._s(_vm.infoMessage)),
                        ])
                      : _vm._e(),
                    _vm.pending
                      ? _c(
                          "v-btn",
                          {
                            staticClass:
                              "font-weight-bold text-uppercase btn-default bg-gradient-default py-2 px-6 me-2 mt-6 mb-2 w-100",
                            attrs: {
                              loading: _vm.loading,
                              elevation: "0",
                              ripple: false,
                              height: "43",
                              color: "#5e72e4",
                              small: "",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.confirm()
                              },
                            },
                          },
                          [_vm._v("Verify")]
                        )
                      : _c(
                          "v-btn",
                          {
                            staticClass:
                              "font-weight-bold text-uppercase btn-default bg-gradient-default py-2 px-6 me-2 mt-6 mb-2 w-100",
                            attrs: {
                              elevation: "0",
                              ripple: false,
                              height: "43",
                              color: "#5e72e4",
                              small: "",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.$router.push({
                                  path: "/pages/authentication/signup/basic",
                                })
                              },
                            },
                          },
                          [_vm._v("Sign Up")]
                        ),
                    _vm.pending
                      ? _c(
                          "p",
                          { staticClass: "text-sm text-body mt-3 mb-0" },
                          [
                            _vm._v(" Didn't get it? "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "ml-2 text-dark text-decoration-none font-weight-bolder",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.resend()
                                  },
                                },
                              },
                              [_vm._v("Send a new code")]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("p", { staticClass: "text-sm text-body mt-1 mb-0" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-dark text-decoration-none font-weight-bolder",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$router.push({
                                path: "/pages/authentication/login",
                              })
                            },
                          },
                        },
                        [_vm._v("Back to log in")]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }